import { useEffect, useRef } from 'react';
import { useDemoServices } from './DemoContext.jsx';

// Local mutations refresh immediately; other tabs/devices are reconciled while visible.
export function useHistorySync(refresh) {
  const services = useDemoServices(), latest = useRef(refresh);
  latest.current = refresh;
  useEffect(() => {
    const sync = () => { if (document.visibilityState !== 'hidden') latest.current(); };
    const timer = setInterval(sync, 10000);
    const unsubscribe = services?.subscribeHistory?.(sync);
    window.addEventListener('focus', sync);
    document.addEventListener('visibilitychange', sync);
    return () => { clearInterval(timer); unsubscribe?.(); window.removeEventListener('focus', sync); document.removeEventListener('visibilitychange', sync); };
  }, [services]);
}
